import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const RCSService = {

    getTemplates: (account_id: number, status = '') => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/v3.1/get-plantillas-rcs`, { params: { account_id, status } });
    },

    statusTemplates: (data: any) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/v3.1/update-plantillas-rcs`, data);
    },

    saveTemplate: (template: any) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/v3.1/create-plantillas-rcs`,  template  );
    },

    delete: ( account_id: number, id: number) => {
        return HTTP.delete<any, any>(`${API_ENDPOINT.CORE}accounts/v3.1/delete-plantillas-rcs`,  { data: { account_id, id } } );
    },
}